import React, { useCallback, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import EventForm from './EventForm'
import API from '../../../../services/api'
import useAPIRequest from '../../../../hooks/useAPIRequest'
import LoadingSpinner from '../../../atoms/loadingspinner/LoadingSpinner'
import Banner from '../../../atoms/banner/Banner'
import Container from '../../../atoms/page/Page'

function EditEvent() {
  const { eventId } = useParams<{ eventId: string }>()

  const callback = useCallback(() => {
    return API.getEvent(eventId)
  }, [eventId])

  const [{ inProgress, data, error }, doApiRequest] = useAPIRequest(callback, null)

  useEffect(() => {
    doApiRequest()
  }, [doApiRequest])

  const onSave = useCallback((data: API.EventRequest) => {
    return API.editEvent(eventId, data)
  }, [eventId])

  const history = useHistory()

  const onCancel = useCallback(() => {
    history.push(`/events/${eventId}/view`)
  }, [history, eventId])

  return (
    <Container>
      {inProgress && <LoadingSpinner />}
      {error && <Banner type='error' active={!!error} message={error?.message} />}
      {data && <EventForm event={data} onSave={onSave} onCancel={onCancel} />}
    </Container>
  )
}

export default EditEvent
